
/**
 * Environment detection and utilities
 */

/**
 * Checks if the application is running in a Cloudflare Workers environment
 */
export const isCloudflareWorker = (): boolean => {
  // This is a simple check that might need to be enhanced
  return typeof globalThis.self !== 'undefined' && 
         typeof globalThis.self.Response !== 'undefined' &&
         typeof globalThis.self.fetch === 'function' &&
         globalThis.self.constructor.toString().includes('WorkerGlobalScope');
};

/**
 * Checks if the application is running in development mode
 */
export const isDevelopmentEnvironment = (): boolean => {
  try {
    return process.env.NODE_ENV === 'development';
  } catch (e) {
    // In some environments, process might not be available
    return false;
  }
};

/**
 * Safely executes code that might not be compatible with all environments
 * @param fn Function to execute
 * @param fallbackFn Fallback function to execute if the main function fails
 * @returns The result of fn() or fallbackFn() if fn() fails
 */
export const safeExecute = <T>(fn: () => T, fallbackFn: () => T): T => {
  try {
    return fn();
  } catch (e) {
    console.error('Error executing environment-sensitive code:', e);
    return fallbackFn();
  }
};

/**
 * Safely access browser APIs that might not be available in all environments
 */
export const safelyAccessBrowser = <T>(accessFn: () => T, fallback: T): T => {
  try {
    if (typeof window === 'undefined') {
      return fallback;
    }
    return accessFn();
  } catch (e) {
    console.error('Error accessing browser API:', e);
    return fallback;
  }
};
